import type { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router'
import { RouteReuseStrategy } from '@angular/router'
import { Injectable } from '@angular/core'

/**
 * A route strategy allowing for route reuse.
 * This is the VERY SAME default Angular strategy
 * Without this the framework component is re-initialize at first navigation
 * Used as a workaround for https://github.com/angular/angular/issues/18374
 */
@Injectable()
export class RouteReusableStrategy extends RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle | null): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig
  }
}
